import { render, staticRenderFns } from "./HandRaise.vue?vue&type=template&id=70874d60&scoped=true&"
import script from "./HandRaise.vue?vue&type=script&lang=js&"
export * from "./HandRaise.vue?vue&type=script&lang=js&"
import style0 from "./HandRaise.vue?vue&type=style&index=0&id=70874d60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70874d60",
  null
  
)

export default component.exports